import React from "react";
import { Box, Typography, Button } from "@mui/material";
import banner from "../../Assets/Images/bottomBanner.png";
import CustomButton from "../Common/CustomButton";
import { useNavigate } from "react-router-dom";

function BottomBanner() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: { xs: "200px", md: "400px" },
        borderRadius: "24px",
        overflow: "hidden",
        backgroundImage: `url(${banner})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        backgroundRepeat: 'no-repeat',
        padding: { xs: 2, md: 18 },
        // paddingTop: { xs: 0, md: 6 },
      }}
    >

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          color: "#fff",
          maxWidth: { xs: "100%", md: "50%" },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: "1.5rem", md: "2rem" },
            fontWeight: "bold",
            marginBottom: 2,
            width: "80%",
          }}
        >
          Your Next Unforgettable Moment Awaits
        </Typography>
        <Box width={"fit-content"} mt={3}>
          <CustomButton onClick={() => navigate('/experience')}>Book Your Next Adventure</CustomButton>
        </Box>
      </Box>
    </Box>
  );
}

export default BottomBanner;
